export default [
  {
    path: '/newsroom',
    name: 'PressReleaseView',
    component: () =>
      import(
        /* webpackChunkName: "platform" */ '@/views/Platform/PressReleaseView.vue'
      ),
    meta: { title: 'Press Release', group: 'platform' },
  },
  {
    path: '/notice_list',
    name: 'GameNoticeView',
    component: () =>
      import(
        /* webpackChunkName: "platform" */ '@/views/Platform/GameNoticeView.vue'
      ),
    meta: { title: 'Game Notice', group: 'platform' },
  },
  {
    path: '/file_list',
    name: 'TUSUploadListView',
    component: () =>
      import(
        /* webpackChunkName: "platform" */ '@/views/Platform/TUSUploadListView.vue'
      ),
    meta: { title: 'File List', group: 'platform' },
  },
]
